<div class="row">
  <div class="col-md-12">
    {{ "GAME" | translate }}
  </div>
  <div class="col-md-12">
    <div class="d-flex">
      <div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="checkbox"
            name="inlineRadioOptions"
            id="all-game-code"
            [checked]="checkAll"
            (change)="onCheckAll()"
          />
          <label class="form-check-label" for="all-game-code">{{
            "ALL" | translate
          }}</label>
        </div>
      </div>
      <div class="border-start ps-3">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            [(ngModel)]="showFilterGameType"
            type="checkbox"
            id="show_group_by_game_type"
          />
          <label class="form-check-label" for="show_group_by_game_type"
            >Show filter group by game type.</label
          >
        </div>
        <hr class="my-1" />
        <div *ngIf="!showFilterGameType">
          <div class="form-check form-check-inline" *ngFor="let game of gameFilter">
            <input
              class="form-check-input"
              type="checkbox"
              name="inlineRadioOptions"
              id="{{ game.game_code }}"
              value="{{ game.game_code }}"
              [(ngModel)]="game.checked"
              (change)="OnChangesSelectedGame()"
            />
            <label class="form-check-label" for="{{ game.game_code }}">
              {{ game.game_name }} <br />
            </label>
          </div>
        </div>
        <div *ngIf="showFilterGameType">
          <div class="mb-2" *ngFor="let type of gameType">
            <ng-container *ngIf="(gameFilter | filterGameType : type).length != 0">
              <small class="opacity-50 d-block">
                {{ type.toUpperCase() | translate }}
              </small>
              <div class="p-1 border rounded">
                <div
                  class="form-check form-check-inline"
                  *ngFor="let game of gameFilter | filterGameType : type"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="inlineRadioOptions"
                    id="{{ game.game_code }}"
                    value="{{ game.game_code }}"
                    [(ngModel)]="game.checked"
                    (change)="OnChangesSelectedGame()"
                  />
                  <label class="form-check-label" for="{{ game.game_code }}">
                    {{ game.game_name }} <br />
                  </label>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
